<span class="cd-fake-link" (click)="onClick()">{{ text }}</span>
